import React from 'react'
import {useCategory} from '@/hooks/category/useCategory'
import {sanitizeSfccContent} from '../../utils/common'
import './seoCopyBlock.css'
import TextBoxExpand from '../ui/text-box-expand'

interface SeoCopyBlockProps {
    category: string
}

export function SeoCopyBlock({category}: SeoCopyBlockProps) {
    const categoryResult = useCategory({parameters: {id: category}})
    const maxLines = 6
    const title = categoryResult?.data?.name
    const seoContent = categoryResult?.data?.c_seoAdditionalCopy
    const sanitizedContent = seoContent ? sanitizeSfccContent(seoContent) : ''

    if (!seoContent) return null

    // Remove the words "read less" (case-insensitive) from the content
    const cleanedContent = sanitizedContent.replace(/read less/gi, '')

    // Create HTML content with dangerouslySetInnerHTML
    const htmlContent = <div dangerouslySetInnerHTML={{__html: cleanedContent}} />

    return (
        <div className="seo-copy-block mx-auto w-[90%] self-center">
            {Boolean(title) && (
                <h1 className="seo-title text-left text-2xl font-bold mb-4 text-blue-03">
                    {title}
                </h1>
            )}
            <TextBoxExpand
                content={htmlContent}
                maxLines={maxLines}
                expandText="Read more"
                collapseText="Read less"
                className="seo-text-box"
                buttonClassName="seo-expand-button"
                dataTestId="seo-copy-block"
                data-testid={'seoCopyBlock-TextBoxExpand'}
            />
        </div>
    )
}
